import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { MarkdownModule } from 'ngx-markdown';
import { DatePipe } from "@angular/common";
import { RouterModule } from '@angular/router';
import { NotificationsListComponent } from './components/notifications-list/notifications-list.component';
import { NotificationsDetailsComponent } from './components/notification-details/notification-details-component';

@NgModule({
    imports: [
        SharedModule,
        MarkdownModule.forRoot(),
        RouterModule
    ],
    declarations: [
        NotificationsListComponent,
        NotificationsDetailsComponent
    ],
    exports: [NotificationsListComponent, NotificationsDetailsComponent],
    providers: [DatePipe]
})
export class NotificationsModule { }
